import React, { Component } from "react";

import { CommonService } from "../js_modules/CommonService";

import { SellToWebSpinnerComponent } from "../common/selltowebspinner/SellToWebSpinnerComponent";

export class XSRFTest3QueryComponent extends Component {

    static getDerivedStateFromProps(props, state) {
        let newState = {};
        try {
            if (state.showSpinner) {
                newState.showSpinner = props.isLoadingData;
            }
        }
        catch (error) {
            console.devError(error);
        }

        return newState;
    }

    constructor(props) {
        super(props);

        this.state = {
            showSpinner: false
        }
    }

    componentDidMount() {
        try {
            CommonService.clientAzureStorageLog("XSRFTest3QueryComponent", "componentDidMount", null, null, null, null, this.props.applicationInsights);
        }
        catch (error) {
            console.logError(error, "XSRFTest3QueryComponent", "componentDidMount");
        }
    }

    render() {
        return <div className="card">
            <div className="card-block" style={{ "padding": "10px" }}>
                <div className="row">
                    <div className="col-auto admin-query-btn">
                        <button className="btn btn-primary" disabled={this.state.showSpinner} onClick={(event) => this.props.onGetPageInfo(event)}>
                            Get Page Info <i className="far fa-redo-alt admin-icon" />
                        </button>
                        <button className="btn btn-primary admin-icon" disabled={this.state.showSpinner} onClick={(event) => this.props.onActionWithValidation(event)}>
                            Action With Validation <i className="far fa-redo-alt admin-icon" />
                        </button>
                        <button className="btn btn-primary admin-icon" disabled={this.state.showSpinner} onClick={(event) => this.props.onActionWithoutValidation(event)}>
                            Action Without Validation <i className="far fa-redo-alt admin-icon" />
                        </button>
                        <button className="btn btn-primary admin-icon" disabled={this.state.showSpinner} onClick={(event) => this.props.onGoToXSRF1(event)}>
                            Go to XSRF1<i className="far fa-redo-alt admin-icon" />
                        </button>
                        <button className="btn btn-primary admin-icon" disabled={this.state.showSpinner} onClick={(event) => this.props.onGoToXSRF2(event)}>
                            Go to XSRF2<i className="far fa-redo-alt admin-icon" />
                        </button>
                    </div>
                    <div className="col-auto admin-query-cube-grid">
                        <SellToWebSpinnerComponent showSpinner={this.state.showSpinner} />
                    </div>
                </div>
            </div>
        </div>;
    }
}